import type { UserRole } from '../modals/ModalShareLoan'
import type { ShareLoanActionsIconType } from './ShareLoanActionsIcon'

const getContentType = (row: UserRole): ShareLoanActionsIconType => {
	if (row.loadingRevoke) return 'loading'
	if (row.markedForDeletion) return 'restore'
	return 'delete'
}

export default getContentType
